var VERSION = "v24.5.3";

export default VERSION;
